import _ from "lodash";

export default {
    state: {
        list: null,

        count: null,

        filters: {
            search: "",
            orderBy: "nome",
            desc: false,
        },

        advertisers: null,
    },

    mutations: {
        ESTABLISHMENTS_SET_LIST(state, list) {
            state.list = list;
        },

        ESTABLISHMENTS_SET_COUNT(state, count) {
            state.count = count;
        },

        ESTABLISHMENTS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value,
            };
        },

        ESTABLISHMENTS_RESET_FILTERS(state) {
            state.filters = {
                search: "",
                orderBy: "data",
                desc: true,
                date: {
                    min: null,
                    max: null,
                },
            };
        },

        SET_ADVERTISERS(state, advertisers) {
            state.advertisers = advertisers;
        },
    },

    getters: {
        mappedAdvertisers(state) {
            const advertisers = state.advertisers;

            return _.map(advertisers, (advertiser) => {
                return {
                    id: advertiser.id,
                    label: advertiser.nome,
                };
            });
        },
    },
};
